

import React, { useState } from 'react';
import styles from './index.module.css';
import HeaderTable from './components/HeaderTable';
import OrderDetail from './components/OrderDetail';

const OrderHeader = () => {
  const [activeSection, setActiveSection] = useState('headers');
  const [selectedOrderNum, setSelectedOrderNum] = useState(null);
  const [savedTableState, setSavedTableState] = useState({
    currentPage: 0,
    searchTerm: '',
    selectedYear: '',
    selectedMonth: '',
    selectedStatus: 'Open',
    sortBy: '',
    sortOrder: 'desc'
  });

  const handleOrderClick = (orderNum, tableState) => {
    setSavedTableState(tableState);
    setSelectedOrderNum(orderNum);
    setActiveSection('detail');
  };

  const handleBackToHeaders = () => {
    setActiveSection('headers');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'headers' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('headers')}
          >
            Order Headers
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'detail' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('detail')}
          >
            Order Detail
          </button>
        </div>

        {activeSection === 'headers' && (
          <div className={styles.sectionContent}>
            <HeaderTable
              onOrderClick={handleOrderClick}
              savedState={savedTableState}
            />
          </div>
        )}

        {activeSection === 'detail' && (
          <div className={styles.sectionContent}>
            <OrderDetail
              initialOrderNum={selectedOrderNum}
              onBack={handleBackToHeaders}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderHeader;